<template>
  <div class="ai-mentor-wrapper">
    <!-- 简历选择 -->
    <div class="head-box">
      <div class="top">
        <img class="icon" src="~@/assets/image/robot_normal.png" />
        <div class="name">快来挑战满分简历吧💯</div>
      </div>
      <div class="content">
        <div class="label">当前辅导简历</div>
        <el-select :value="cvName" disabled>
          <el-option :label="cvName" :value="cvName"></el-option>
        </el-select>
      </div>
    </div>
    
    <!-- 内容 -->
    <div class="ai-mentor-content">
      <div class="head-title">
        <span class="iconfont iconaidaoshi"></span>
        <span class="title" v-if="aiStep === 'complete'">解析完成</span>
        <span class="title" v-else>请填写求职信息</span>
      </div>

      <!-- 求职信息填写 -->
      <div class="job-information" v-if="aiStep === 'form'">
        <div class="form-title">求职意向</div>
        <el-form ref="jobInformationForm" :model="jobInformation" :rules="jobInformationRules">
          <div class="intention-form">
            <div class="form-items">
              <div class="form-item">
                <div class="label">职位类型</div>
                <el-form-item prop="jobType">
                  <el-input
                    placeholder="请输入职位类型"
                    v-model="jobInformation.jobType"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-item">
                <div class="label">求职状态</div>
                <el-form-item prop="job_search_status">
                  <el-select
                    v-model="jobInformation.job_search_status"
                    placeholder="请选择求职状态"
                    popper-class="ai-mentor-select-popper"
                  >
                    <el-option
                      v-for="(item) in jobStatusOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="label">JD</div>
              <el-form-item prop="jd">
                <el-input
                  type="textarea"
                  placeholder="请填写"
                  v-model="jobInformation.jd"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-title">其他关注问题</div>
          <div class="intention-form question">
            
            <div class="form-item">
              <el-form-item prop="user_concerns">
                <el-input
                  type="textarea"
                  placeholder="请填写你的问题"
                  v-model="jobInformation.user_concerns"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="form-buttons">
          <CompleteButton
            text="提交"
            @clickBtn="submitJobInformation"
          />
        </div>
      </div>

      <!-- 解析中 / 解析异常 -->
      <div class="ai-parsing" v-if="aiStep === 'parsing' || aiStep === 'parsingException'">
        <div class="job-card">
          <div class="job-name">{{jobInformation.jobType || ''}}</div>
          <div class="job-status">{{jobInformation.job_search_status || ''}}</div>
        </div>
        <!-- 解析中 -->
        <div class="loading" v-if="aiStep === 'parsing'">解析中~~~~</div>
        <!-- 解析异常 -->
        <template v-else>
          <div class="head-title" style="margin-top: 36px;">
            <span class="iconfont iconaidaoshi"></span>
            <span class="title">解析完成</span>
          </div>
          <div class="jd-form">
            <div class="question-list">
              <div class="item" v-for="(item, index) in missingQuestionList" :key="index">
                {{ item.suggestion }}
              </div>
            </div>
            <div class="question">
              <el-input
                type="textarea"
                placeholder="请填写补充信息"
                v-model="supplementary_info"
              ></el-input>
            </div>
            <div class="form-buttons">
              <CompleteButton
                text="跳过"
                type="cancel"
                @clickBtn="parseResume"
              />
              <CompleteButton
                text="再次提交"
                @clickBtn="submitJobInformation(true)"
              />
            </div>
          </div>
        </template>
      </div>

      <!-- 开始评估完成 -->
      <div class="ai-parse-resume" v-if="aiStep === 'parseResume'">
        <div class="job-card">
          <div class="job-name">{{jobInformation.jobType || ''}}</div>
          <div class="job-status">{{jobInformation.job_search_status || ''}}</div>
        </div>
        <div class="results-content">
          <div class="results-head">
            <div class="time-info">
              <div class="label">深度思考</div>
              <div class="time">{{ formatTime }}</div>
            </div>
            <div class="loading">分析中...</div>
          </div>

          <div class="results-box">
            <!-- 分析进度 -->
            <div class="think-step">
              <template v-for="(item, index) in aiThinkStepOptions">
                <div class="step" :key="index" v-if="aiThinkStep >= index">
                  <div class="iconfont iconxuanzhong" v-if="aiThinkStep > index"></div>
                  <div class="iconfont loading" v-else></div>
                  <div class="label">{{item}}</div>
                </div>
              </template>
            </div>
            <!-- 分析结果 -->
            <div class="content" id="aiMentorContent">
              <!-- 开始思考 -->
              <!-- <div class="item-content" v-html="aiThinkStep0Content"></div> -->

               <!-- 简历评估 -->
              <div class="ai-think-title" v-if="aiThinkStep1Content" style="margin-top:0">简历评估</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep1Content)"></div>

              <!-- 职位评估 -->
              <div class="ai-think-title" v-if="aiThinkStep2Content">职位评估</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep2Content)"></div>

              <!-- 简历优化 -->
              <!-- <div class="ai-think-title" v-if="aiThinkStep3Content">简历优化</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep3Content)"></div> -->

              <!-- 报告生成 -->
              <!-- <div class="ai-think-title" v-if="aiThinkStep4Content">报告生成</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep4Content)"></div> -->

              <!-- 用户鼓励 -->
              <div class="ai-think-title" v-if="aiThinkStep5Content"></div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep5Content)"></div>
            </div>
          </div>
          <div class="form-buttons" v-if="aiThinkStep > 5 ">
            <!-- @clickBtn="submitJobInformation(true)" -->
            <CompleteButton
              text="查看报告"
            />
          </div>
        </div>

      </div>

    </div>
    
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';
import { marked } from 'marked';

// components
import CompleteButton from '../CompleteButton/CompleteButton.vue';

const jobStatusOptions = ['应届生求职','转行求职（跨专业，跨行业）','高竞争力岗位求职（国企、央企、外企、金融）','留学生求职']
const aiThinkStepOptions = ['开始思考','简历评估','职位评估','简历优化', '报告生成', '用户鼓励']
export default {
  name: 'AiMentor',
  props: {
    cvDetail: {
      type: Object,
      default: () => ({}),
    },
    profile: {
      type: Object,
      default: () => ({}),
    },
    cvName: {
      type: String,
      default: '',
    },
  },
  components: {
    CompleteButton,
  },
  data() {
    return {
      jobStatusOptions,
      aiMentorCheckCount: 0, // 简历评估次数

      // 职位信息表单
      jobInformation:{
        jobType: '',
        job_search_status: '',
        jd: ``,
        user_concerns: '',
      },
      jobInformationRules: {
        jobType: [
          { required: true, message: '请填写职位类型', trigger: 'blur' },
        ],
        job_search_status: [
          { required: true, message: '请选择求职状态', trigger: 'change' },
        ],
        jd: [
          { required: true, message: '请填写JD信息', trigger: 'blur' },
        ],
        user_concerns: [
          { required: true, message: '请填写你的关注问题', trigger: 'blur' },
        ],
      },
      formSubmitLoading: false,
      aiStep: 'form', //提交信息form，解析中parsing，解析异常parsingException，评估开始parseResume
      missingQuestionList: [], //解析问题列表
      supplementary_info: '', //用户补充的问题

      // 进入解析阶段
      aiThinkStep: 0, //思考阶段
      thinkTime: 0, //思考时间
      thinkTimer: null, //定时器
      aiThinkStepOptions,
      aiThinkStep1Content: '', // 简历评估
      aiThinkStep2Content: '', // 职位评估
      // aiThinkStep3Content: '', // 简历优化
      // aiThinkStep4Content: '', // 报告生成
      aiThinkStep5Content: '', // 用户鼓励
      
    };
  },
  computed: {
    formatTime() {
      let time = this.thinkTime
      if(time < 60){
        return `${time}s`
      }else if(time < 3600){
        let minute = Math.floor(time / 60)
        let second = time - minute * 60
        return `${minute}m${second}s`
      }else{
        let hour = Math.floor(time / 3600)
        let minute = Math.floor((time - hour * 3600) / 60)
        let second = time - hour * 3600 - minute * 60
        return `${hour}h${minute}m${second}s`
      }
    },
  },
  created() {
    return
    this.aiThinkStep1Content = `
【用户画像】
- 职业阶段：初级专业人士，约0-1年相关经验（实习经历）
- 专业领域：计算机科学，偏向产品设计与前端开发
- 核心技能：需求分析、原型设计、用户体验、项目管理
- 潜在定位：最适合初级产品经理/助理，优势在于快速学习和用户洞察
- 职业轨迹：呈现积极探索和快速学习的发展态势

【结构评估】
- 关键优势：项目经历和个人总结突出，展现了较强的产品sense和学习能力。
- 主要问题：技能描述过于宽泛，缺乏前端技术栈的明确展示。
- 重点缺失：缺少对个人技术能力（如HTML、CSS、JavaScript等）的量化描述。
- 优化建议：
    1. 将“技能”部分拆分为“产品技能”和“技术技能”，分别列出。
    2. 在项目经历中突出技术实现细节，量化技术贡献。
    3. 调整个人总结，突出技术背景和对前端开发的兴趣。

【经历复盘】

✦ 产品实习生 [XX科技有限公司]
- 核心价值：展现了用户增长、数据分析和跨部门协作能力。
- 叙述评估：数据成果亮眼，但缺少对具体产品策略的描述。
- 改进建议：增加对小程序产品定位、用户画像和增长策略的描述。
- 与目标的关联：直接关联产品经理岗位，突出产品sense。

✦ 移动小程序设计 [项目负责人]
- 核心价值：展现了独立负责产品设计全流程的能力。
- 叙述评估：较为全面，但缺少对设计理念和创新点的提炼。
- 改进建议：突出设计理念，例如“采用XX设计原则，提升用户转化率”。
- 与目标的关联：强化产品设计能力，突出项目管理经验。

✦ VR app原型设计 [项目组长]
- 核心价值：展现了市场分析、用户研究和原型设计能力。
- 叙述评估：内容详实，但缺少对技术可行性的评估。
- 改进建议：增加对VR技术选型和技术挑战的描述。
- 与目标的关联：体现对新兴技术的关注，展现学习能力。

➤ 经历连贯性分析：项目经历和实习经历相互补充，展现了从产品设计到用户增长的完整能力链条。

【潜力挖掘】
低估经历重塑：
- 原描述："推动小程序上线，上线后监测用户拉新、留存等数据并汇报，每周根据数据提出优化意见和需求，上线后1个月获得8万新用户，次月留存率13%+"
    优化为："主导小程序上线后的用户增长策略，通过A/B测试和用户行为分析，实现首月新增用户8万，次月留存率提升至13%，显著提升用户粘性。"

隐藏技能激活：
- 交互设计 → 转化为：具备用户体验思维，能够设计简洁高效的用户界面，提升用户满意度。

差异化标签：
- 对用户体验和产品运营有独到的见解与想法 → 可进一步发展为：具备数据驱动的产品优化能力，能够通过数据分析发现用户痛点并提出解决方案。

【提升方案】

核心强化点：
1. 产品实习经历 - 建议：突出数据分析和用户增长方面的贡献，量化成果。
2. 项目经历 - 建议：增加技术实现细节，展现技术背景。
3. 个人技能 - 建议：拆分技能列表，突出前端技术栈，例如“熟练掌握HTML、CSS、JavaScript，了解Vue/React等框架”。

内容调整：
- 建议删减：普通话等级证书，原因：与求职岗位关联度较低。
- 建议补充：个人作品链接（如GitHub、CodePen），示例：[GitHub: github.com/your-username]

`
    this.aiThinkStep2Content = `
# 职位六维分析报告
基于所提供JD，进行以下六个维度的全面分析：

【硬门槛】
- 必备要求：
  *   3年以上前端开发经验（JD未明确说明，但根据岗位职责和“丰富经验”推断）
  *   精通 JavaScript 语言开发
  *   熟悉主流前端开发框架及底层原理
- 加分项：
  *   Android/iOS移动端或小程序/H5等前端开发经验
  *   熟悉 OC/Java 语言开发
  *   熟悉 React Native、Taro 等跨端解决方案
  *   熟悉大前端性能问题排查，并具有性能优化经验
  *   研究过优秀开源软件的源码并有心得
  *   对 AI Coding 等新技术感兴趣
- 隐藏要求：
  *   良好的代码规范和质量意识
  *   较强的抗压能力，能应对高并发、高性能的业务需求

【能力模型】
- 核心能力1：**移动端开发能力** - 重要度[5/5]
  *   证据要求：项目经验、技术博客、开源项目贡献
  *   应用场景：负责酒店用户端频道、列表页相关的业务支撑工作，解决移动端开发遇到的痛点难点问题。
- 核心能力2：**架构设计能力** - 重要度[4/5]
  *   证据要求：参与过的复杂项目架构设计经验、技术方案文档
  *   应用场景：提升业务开发质量和开发效率，具备复杂业务架构的优化演进落地能力。
- 核心能力3：**业务理解能力** - 重要度[4/5]
  *   证据要求：对业务的理解和思考、解决业务问题的案例
  *   应用场景：掌握所负责业务的核心领域知识，对使用技术手段赋能业务有强烈兴趣。
- 核心能力4：**工程化能力** - 重要度[3/5]
  *   证据要求：参与过的工程化项目、工具开发经验
  *   应用场景：负责终端工程化工具的建设与迭代，并建立可量化的指标驱动业务改进。

【行业术语】
- 专业术语对照表：
  *   "移动端" → "Native App/H5/小程序"
  *   "前端" → "Web/大前端"
  *   "优化" → "性能优化/体验优化/架构优化"
- 高频关键词(出现≥3次)：
  *   "业务" - 出现[6]次
  *   "开发" - 出现[5]次
  *   "技术" - 出现[4]次

【业务痛点】
- 核心问题：提升酒店用户端频道、列表页的开发质量和效率，优化用户体验，解决移动端开发遇到的痛点难点问题。
- 期望解决方案：候选人能主导技术攻坚，优化架构设计，建设工程化工具，并能深入理解业务，用技术赋能业务。
- 潜在项目：
  *   酒店用户端频道、列表页的重构或优化
  *   移动端性能优化项目
  *   工程化工具的开发和迭代

【竞争画像】
- 典型竞争者背景：
  *   学历：本科及以上，计算机相关专业
  *   工作经验：3-5 年前端开发经验
  *   技能：精通 JavaScript，熟悉主流前端框架，有移动端开发经验
  *   公司：一线互联网公司或知名创业公司
- 竞争激烈度：较高，前端开发岗位竞争一直比较激烈，尤其是在美团这样的大公司。
- 差异化策略：
  *   突出移动端开发经验和性能优化经验
  *   展示对业务的理解和思考
  *   强调工程化能力和解决问题的能力

【隐性规则】
- 未明说的评判标准：
  *   代码质量和规范
  *   解决问题的能力
  *   学习能力和技术热情
- 潜在偏好：
  *   有大厂经验者优先
  *   有开源项目贡献者优先
- 晋升线索：
  *   从负责业务支撑到主导技术攻坚
  *   从参与项目到负责工程化工具建设

# 简历与职位匹配分析

【简历匹配度分析框架】

1. 基础条件匹配
✅ 达标项：
  *   [学历]：要求本科 → 已满足(中国地质大学本科)
  *   [专业]：要求计算机相关 → 已满足(计算机科学专业)
  *   [技能]：Axure，Visio，Mindmanager → 满足部分需求
⚠️ 风险项：
  *   [工作经验]：要求3年以上 → 目前实习经历(可强调项目经验)
  *   [技能]：要求JavaScript → 未明确体现(可补充课程项目经验)
  *   [技能]：要求熟悉主流前端框架 → 未明确体现(可补充项目经验)
  *   [技能]：要求移动端开发经验 → 未明确体现(可补充项目经验)
  *   补救建议：在技能部分添加JavaScript，主流前端框架，移动端开发相关技能，并补充相关的项目案例

2. 核心能力匹配
⭐ 优势匹配项：
  *   [产品设计能力]：
    *   协助完成小程序流程和原型设计(匹配部分架构设计要求)
    *   撰写需求文档和分析报告
  *   [项目管理能力]：
    *   推动小程序上线，并进行数据分析和优化
    *   团队协作能力
 待加强项：
  *   [移动端开发能力]：
    *   目前缺乏直接经验
    *   建议补充：添加参与的移动端项目案例
  *   [架构设计能力]：
    *   目前缺乏直接经验
    *   建议补充：添加参与的架构设计项目案例
  *   [工程化能力]：
    *   目前缺乏直接经验
    *   建议补充：添加参与的工程化项目案例

【术语匹配度】
- 行业术语使用评估：简历中缺乏行业术语，表达较为普通。
- 术语优化建议：
  *   原表述："完成产品的信息架构和功能架构"
  *   优化为："完成产品的信息架构和功能架构设计，并采用XX技术进行实现"
  *   原表述："对产品原型进行UI界面设计"
  *   优化为："对产品原型进行UI界面设计，并遵循XX设计规范"

【竞争力差异分析】
- 相对优势：
  *   具备产品设计和项目管理经验
  *   有一定的数据分析能力
- 相对劣势：
  *   缺乏前端开发经验
  *   缺乏移动端开发经验
  *   缺乏架构设计经验
  *   缺乏工程化经验
- 差异化机会：
  *   强调产品设计和项目管理经验对前端开发的帮助
  *   展示学习能力和技术热情
  *   突出对业务的理解和思考

# 简历优化行动计划
根据匹配分析，按紧急程度排序的优化方案：

🔴 紧急项（影响过筛）：
  *   在技能部分明确添加"精通JavaScript，熟悉React/Vue/Angular等主流前端框架，了解移动端开发"等必备技能
  *   在项目经历中补充前端开发相关的项目经验，例如使用JavaScript和前端框架开发网页或移动应用
  *   调整工作经历顺序，突出与前端开发相关的经验

🟠 高杠杆项（小改动大提升）：
  *   将普通工作描述改写成包含行业术语的量化成果，例如"使用React开发了XX组件，性能提升了XX%"
  *   增加与岗位核心能力直接相关的关键词，例如"性能优化"、"架构设计"、"工程化"
  *   将实习经历描述成项目经历，突出个人在项目中的贡献和成果

🟢 增值项（差异化）：
  *   添加个人技术博客或GitHub链接，展示技术能力和学习热情
  *   突出对业务的理解和思考，例如"对酒店用户端频道、列表页的优化建议"

# 表达优化示例
针对简历中需要提升的关键部分，提供具体的改写示例：

【优化示例1】- 针对[移动端开发能力]
  *   原表达："协助产品经理完成XX图像处理小程序的流程和原型设计"
  *   优化表达："参与XX图像处理小程序的开发，负责前端页面开发，使用React Native实现了XX功能，并进行了性能优化，提升了用户体验"

【优化示例2】- 针对[架构设计能力]
  *   原表达："完成产品的信息架构和功能架构"
  *   优化表达："负责产品的信息架构和功能架构设计，并采用模块化设计思想，提升了代码的可维护性和可扩展性"

【STAR案例模板】
针对该岗位最看重的移动端开发能力，建议准备以下STAR结构案例：

  *   情境(S)：公司需要开发一款新的移动应用，但技术团队缺乏移动端开发经验。
  *   任务(T)：作为前端开发，需要负责移动应用的前端页面开发和性能优化。
  *   行动(A)：学习React Native，并使用React Native开发了移动应用的前端页面，同时进行了性能优化，例如使用虚拟DOM、懒加载等技术。
  *   结果(R)：成功开发了移动应用的前端页面，并提升了应用的性能，用户体验得到了明显改善。

# 综合匹配评估

【整体匹配度】：★★☆☆☆
  *   硬性条件匹配：30%
  *   核心能力匹配：40%

【竞争力预测】
完成建议的优化后，预计您的简历竞争力：
  *   初筛通过概率：较低
  *   面试邀约可能性：较低
  *   相对竞争者优势：略逊

此分析报告基于当前招聘市场数据和行业趋势，旨在提供职位的全面透视和针对性简历优化建议，帮助求职者提升求职效率和成功率。
`
    // this.aiStep = 'parseResume'
    // this.aiMentorOptimization()
  },
  watch: {
    cvDetail: {
      handler (newVal) {
        if(newVal && newVal?.basic_info?.token){
          //有简历token，读取本地信息
          this.initAiFormData()
        }
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions('editor', ['getFormatCvInfo']),
    formValidate () {
      let flag = false
      this.$refs['jobInformationForm'].validate(valid => {
        flag = valid
      })
      return flag
    },
    formatMarkedHtml (html) {
      // // 处理markdown语法
      // let result = marked(html)
      // // 处理换行
      // result = result.replace(/<br\s*\/?>/g, '\n')
      // return result
      let result = html.replace(/\`\`\`markdown/g, '')
      result = result.replace(/\`\`\`/g, '')
      
      return marked(result)
    },
    initAiFormData(){
      let aiMentorKey = `${this.cvDetail?.basic_info?.token}_aiMentor`
      let aiMentorData = localStorage.getItem(aiMentorKey)
      if(aiMentorData){
        aiMentorData = JSON.parse(aiMentorData)
        // aiMentorData jobInformation, aiStep, thinkTime, aiThinkStep1Content, aiThinkStep2Content
        // 处理表单数据
        if(aiMentorData?.jobInformation){
          this.jobInformation = {
            ...this.jobInformation,
            ...aiMentorData?.jobInformation
          }
        }
        return
        // 标记解析阶段已结束
        if(aiMentorData?.aiStep && aiMentorData?.aiStep == 'parseResume'){
          this.aiStep = 'parseResume'
          this.thinkTime = aiMentorData?.thinkTime
          this.aiThinkStep1Content = aiMentorData?.aiThinkStep1Content
          this.aiThinkStep2Content = aiMentorData?.aiThinkStep2Content
          // 直接走完
          this.getAiThink5Content(true)
        }

      }
    },

    // 提交职位信息
    async submitJobInformation(submitAgain){
      // 检测表单完整性
      let flag = submitAgain ? !!this.supplementary_info : this.formValidate();
      let aiMentorKey = `${this.cvDetail?.basic_info?.token}_aiMentor`

      // 再次提交信息
      // let againValueFlag = submitAgain && !this.supplementary_info
      if (!flag ) {
        this.$message.error('请完善所有信息')
        return
      }
      if(this.formSubmitLoading) return;
      this.formSubmitLoading = true;

      // 提交信息，进入解析中
      this.aiStep = 'parsing'
      this.missingQuestionList = []

      // 保存表单数据
      localStorage.setItem(aiMentorKey, JSON.stringify({
        jobInformation: this.jobInformation,
      }))

      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        target_position: `职位类型：${this.jobInformation.jobType}；JD：${this.jobInformation.jd}`,
        job_search_status: this.jobInformation.job_search_status,
        user_concerns: this.jobInformation.user_concerns,
      }
      // 是否是再次提交信息
      if(submitAgain){
        formData.supplementary_info = this.supplementary_info
      }

      
      try {
        let res = await api.AI.aiMentorInputCheck(formData)
        // 标记请求完成
        this.formSubmitLoading = false;
        if(res.code === 1000){
          let { missingItems } = res.data.result
          // 检查一下是否有ai给的问题
          if(missingItems.length > 0){
            this.aiStep = 'parsingException'
            this.missingQuestionList = missingItems
          }else{
            // ai没有给需要补充的问题，直接进行解析
            this.parseResume()
          }
        }else{
          this.$message.error(res.msg)
          // 提交信息失败，退回填写表单
          this.aiStep = 'form'
        }
      } catch (error) {
        console.error(error)
        this.$message.error('AI 开小差了～')
        // 提交信息失败，退回填写表单
        this.aiStep = 'form'
        // 标记请求完成
        this.formSubmitLoading = false;
      }
    },

    // 开始计算ai思考时间
    startAiThinkTime(){
      this.thinkTime = 0
      clearInterval(this.thinkTimer)
      this.thinkTimer = setInterval(() => {
        this.thinkTime += 1
      }, 1000);
    },

    // 进行解析
    async parseResume(){
      // 进入简历评估
      this.aiStep = 'parseResume'
      // 开始计算ai思考时间
      this.startAiThinkTime()

      // 进入思考阶段
      this.aiThinkStep = 0
      setTimeout(() => {
        // 进入简历评估阶段
        this.aiThinkStep = 1
      }, 0.3 * 1000);


      // // 模拟完成
      // setTimeout(() => {
      //   this.jobAssessment()
      // }, 1 * 1000);

      // 整理简历信息
      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        target_position: `职位类型：${this.jobInformation.jobType}；JD：${this.jobInformation.jd}`,
        job_search_status: this.jobInformation.job_search_status,
        user_concerns: this.jobInformation.user_concerns,
        supplementary_info: this.supplementary_info
      }
      api.AI.aiMentorCvAssessment({
        data: formData,
        onMessage: (data={}) => {
          let { choices } = data
          if(choices && choices.length > 0){
            choices.forEach(item => {
              let { delta } = item
              if(delta && delta.content){
                // 先滚一次
                this.scrollAiMentorContent()
                this.aiThinkStep1Content += delta.content
                // 先渲染，再滚动
                setTimeout(() => {
                  this.scrollAiMentorContent()
                }, 0.2 * 1000);
              }
            })
          }
        },
		    onComplete: (data) => {
          console.log('进行解析 end=>', data)
          console.log('进行解析 end=> aiThinkStep1Content', this.aiThinkStep1Content)
          // 进入下一阶段
          this.jobAssessment()
        },
        onError: (error) => {
          console.log('进行解析 error=>', error)
          this.$message.error('AI 开小差了～')
        }
      })
    },

    // 职位评估
    async jobAssessment(){
      // 进入职位评估阶段
      this.aiThinkStep = 2

      // 整理简历信息
      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        target_position: `职位类型：${this.jobInformation.jobType}；JD：${this.jobInformation.jd}`,
        job_search_status: this.jobInformation.job_search_status,
        user_concerns: this.jobInformation.user_concerns,
        supplementary_info: this.supplementary_info
      }
      api.AI.aiMentorJobAssessment({
        data: formData,
        onMessage: (data={}) => {
          let { choices } = data
          if(choices && choices.length > 0){
            choices.forEach(item => {
              let { delta } = item
              // 先滚一次
              this.scrollAiMentorContent()

              if(delta && delta.content){
                this.aiThinkStep2Content += delta.content
              }
              // 先渲染，再滚动
              setTimeout(() => {
                this.scrollAiMentorContent()
              }, 0.2 * 1000);
            })
          }
        },
		    onComplete: (data) => {
          console.log('进行解析 end=>', data)
          console.log('进行解析 end=> aiThinkStep2Content', this.aiThinkStep2Content)

          // 进入下一阶段
          this.aiMentorOptimization()
        },
        onError: (error) => {
          console.log('进行解析 error=>', error)
          this.$message.error('AI 开小差了～')
        }
      })
    },

    // 简历优化、报告生成
    async aiMentorOptimization(){
      // 进入简历优化阶段
      this.aiThinkStep = 3

      // 整理简历信息
      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        cv_analysis: this.aiThinkStep1Content, //简历分析结果
        job_analysis: this.aiThinkStep2Content, //职位分析结果
      }
      let promiseList = [
        api.AI.aiMentorOptimization(formData),
        api.AI.aiMentorReport(formData),
      ]
      try {
        let resList = await Promise.all(promiseList)
        if(resList && resList.length > 0){
          let [optimizationRes, reportRes] = resList
          if(optimizationRes.code === 1000 && reportRes.code === 1000){
            console.log('报告生成完毕!')

            // 模拟进入报告生成阶段
            setTimeout(() => {
              this.aiThinkStep = 4
            }, 0.3 * 1000);

            // 展示用户鼓励
            setTimeout(() => {
              this.getAiThink5Content()
            }, 0.6 * 1000);
          }else{
            this.$message.error('AI 开小差了～')
          }
        }
        else{
          this.$message.error('AI 开小差了～')
        }
      } catch (error) {
        console.log('进行解析 error=>', error)
        this.$message.error('AI 开小差了～')
      }

    },

    // 用户鼓励
    async getAiThink5Content(isEnd){
      this.aiThinkStep = 5
      this.aiThinkStep5Content += `对着屏幕大叫3声：Passion！！！Passion！！！Passion！！！ <br/>`
      // 滚动到底部
      this.scrollAiMentorContent()
      setTimeout(() => {
        this.aiThinkStep5Content += `我一定能找到好工作！！！`
        setTimeout(() => {
          // 滚动到底部
          this.scrollAiMentorContent()
        }, 0.2 * 1000);
      }, isEnd ? 0 : 300);


      // 标记ai流程走完了
      this.aiThinkEnd()
    },

    // 思考结束
    aiThinkEnd(){
      this.aiThinkStep = 6
      clearInterval(this.thinkTimer)

      // 更新本地存储
      let aiMentorKey = `${this.cvDetail?.basic_info?.token}_aiMentor`
      localStorage.setItem(aiMentorKey, JSON.stringify({
        jobInformation: this.jobInformation,
        aiStep: this.aiStep,
        thinkTime: this.thinkTime,
        aiThinkStep1Content: this.aiThinkStep1Content,
        aiThinkStep2Content: this.aiThinkStep2Content,
      }))
    },

    // 滚动到底部
    scrollAiMentorContent(){
      let aiMentorContent = document.getElementById('aiMentorContent')
      if(aiMentorContent){
        aiMentorContent.scrollTop = aiMentorContent.scrollHeight
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import './index.scss';
</style>
<style lang="scss">
@import '@/assets/css/variable.scss';
.ai-mentor-select-popper {
  background-color: transparent !important;
  border-color: $select-border-color !important;
  background: linear-gradient(45deg, $select-bg-start-color 0%, $select-bg-middle-color 62%, $select-bg-end-color 100%);
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          color: $text-color;
          .es-highlighter {
            color: $theme-color;
          }
          &.hover,
          &:hover {
            background-color: $select-dropdown-item-hover;
          }
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>